import React from 'react';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import clsx from "clsx";
import {DataTableLocalization, Translate} from "../../../../../config/Translate";
import axios from "axios";
import {defaultVariabls} from "../../../../../config/index";
import MaterialTable from "material-table";
import {tableIcons} from "../../../../../config/design/TableIcons";
import {Link, withRouter} from "react-router-dom";
import { withSnackbar } from 'notistack';
import {TableCount, TablePage} from "../../../../../config/Permissions";
import Typography from "@material-ui/core/Typography/Typography";
import AppCardLoaderTable from "../../../../components/Skeletons/AppCardLoaderTable";
import Container from "@material-ui/core/Container/Container";
import Button from "@material-ui/core/Button/Button";
import {currencySymbol, price} from "../../../../../config/values";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {connect} from "trim-redux";
import Alert from "@material-ui/lab/Alert/Alert";


class ViewTransferPricing extends React.Component {
    constructor(props) {
        super(props)
        this.tableRef = React.createRef()
    }
    classes = this.props.classes;
    fixedHeightPaper = clsx(this.classes.paper, this.classes.fixedHeight);
    state = {
        columns: [
            {
                title: Translate.min_weight,
                field: 'min_weight',
                render: rowData =>
                    <Typography>
                        {rowData.min_weight} {Translate.gram}
                    </Typography>

            },
            {
                title: Translate.max_weight,
                field: 'max_weight',
                render: rowData =>
                    <Typography>
                        {rowData.max_weight} {Translate.gram}
                    </Typography>
            },
            {
                title: Translate.inside_price,
                field: 'inside_price',
                render: rowData =>
                    <>
                    <Typography>
                        {rowData.inside_price} {currencySymbol}
                    </Typography>
                    </>
            },
            {
                title: Translate.outside_price,
                field: 'outside_price',
                render: rowData =>
                    <>
                    <Typography>
                        {rowData.outside_price} {currencySymbol}
                    </Typography>
                    </>
            }
        ],
        data: [],
        loading:false,
    };
    componentDidMount(){
        this.loadData();
    }
    loadData(){
        this.tableRef.current && this.tableRef.current.onQueryChange()
    }

    render(){
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        return (
            <>
                {
                    this.state.loading ? <AppCardLoaderTable/> :
                        <Container maxWidth="xl">
                            <MaterialTable
                                icons={tableIcons}
                                title={Translate.viewTransferPricing}
                                localization={DataTableLocalization}
                                columns={this.state.columns}
                                data={query =>
                                    new Promise((resolve, reject) => {
                                        axios.get(`${defaultVariabls.url}/transfer_price/quickView?page=${query.page + 1}&per_page=${query.pageSize}`, config)
                                            .then(response => {
                                                let data = [];
                                                // eslint-disable-next-line
                                                response.data.data.map((row) => {
                                                    data.push({
                                                        min_weight: row.min_weight,
                                                        max_weight:row.max_weight,
                                                        inside_price:row.inside_price,
                                                        outside_price:row.outside_price,
                                                        id:row.id,
                                                        created_at:row.created_at,
                                                    })
                                                });
                                                resolve({
                                                    data: data,
                                                    page: response.data.current_page - 1,
                                                    totalCount: response.data.total,
                                                })
                                            }).catch(error => {
                                            console.log(error)
                                        })
                                    })
                                }
                                options={{
                                    pageSize: TablePage,
                                    pageSizeOptions: TableCount,
                                    search:false,
                                }}
                            />
                        </Container>
                }
            </>
        );
    }
}
const mstp = state => ({
    x_price: state.x_price,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(ViewTransferPricing)))));